import { css } from '@lastbrand/web-ui-styled-system/css'

// Figma: Quince Design System 2.0 → Widgets → ProductName (node 8306:145026).
// The container/header/rating style pairs below are mutually exclusive per variant
// (picked in product-name-ds.tsx); merging them with cx() is unreliable because Panda
// emits one class per property value and stylesheet order, not cx() order, decides.

export const containerDefaultCss = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 'space-12',
  width: 'full',
})

export const containerRatingSideCss = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: { base: 'space-12', lg: 'space-16' },
  width: 'full',
})

// Layout-neutral test-id host around the web-ui StarRatingBar (which doesn't
// forward data-* props); display:contents keeps the rating row's flex intact.
export const starsWrapperCss = css({
  display: 'contents',
})

export const headerDefaultCss = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 'space-4',
  width: 'full',
})

export const headerRatingSideCss = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 'space-4',
  flex: '1 0 0%',
  minWidth: 0,
})

export const brandNameCss = css({
  textStyle: 'title-14',
  color: 'mediumgray',
})

export const brandNameLinkCss = css({
  display: 'inline-block',
  borderBottom: '1px solid transparent',
  _hover: {
    color: 'black',
    borderBottom: '1px solid token(colors.black)',
  },
})

// `textWrap: 'wrap'` overrides the DS global `text-wrap: balance` on `h1` (STRFRNT-16487): balance
// evens the line lengths, which on mweb left the product name visibly narrower than its container.
// Design confirmed the name should take the full container width and wrap normally.
export const titleCss = css({
  textStyle: { base: 'body-16', lg: 'body-20' },
  fontStyle: 'normal',
  color: 'black',
  width: 'full',
  textWrap: 'wrap',
})

export const ratingDefaultCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-4',
  width: 'full',
  cursor: 'pointer',
})

export const ratingRatingSideCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-4',
  flexShrink: 0,
  cursor: 'pointer',
})

export const ratingValueCss = css({
  textStyle: 'body-14-strong',
  color: 'black',
  pl: 'space-4',
})

export const reviewCountCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-2',
  textStyle: 'title-12',
  color: 'black',
})

export const reviewCountTextCss = css({
  borderBottom: '1px solid token(colors.black)',
})
